import './home.css';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import FoodImage from '../assets/img/foodREmoveBG.webp';
import { COMPANY } from '../data/content';

const Hero = () => {
  return (
    <section id='home' className='fondo relative pt-28 lg:pt-32 pb-16 lg:pb-24'>
      <div className='container mx-auto px-4 relative z-[1]'>
        <div className='grid lg:grid-cols-2 gap-12 lg:gap-16 items-center'>
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <p className='text-accent font-semibold text-sm uppercase tracking-wider mb-4'>Huaraz, Perú</p>
            <h1 className='text-4xl md:text-5xl lg:text-[3.25rem] font-bold text-ink leading-tight mb-5'>
              Logística y software para mover tu ciudad
            </h1>
            <p className='text-paragraph text-lg max-w-xl mb-6'>
              Waras Delivery lleva comida, paquetes y encargos a la puerta. App, afiliación y motorizados son
              gratis. Waras Restaurants organiza el salón: POS, mesas, cocina y carta QR.
            </p>
            <p className='inline-flex items-center text-sm font-semibold text-accent bg-accent-light rounded-full px-3 py-1 mb-8'>
              Delivery, negocios y drivers: 100% gratis
            </p>
            <div className='flex flex-col sm:flex-row gap-3'>
              <a href={COMPANY.playStore} target='_blank' rel='noopener noreferrer' className='btn btn-lg'>
                Pedir en la app
              </a>
              <Link to='/afiliate' className='btn btn-lg btn-outline'>
                Soy un negocio
              </Link>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className='flex justify-center lg:justify-end'
          >
            <img
              src={FoodImage}
              alt='Pedido Waras Delivery'
              width={512}
              height={512}
              fetchPriority='high'
              decoding='async'
              className='w-full max-w-md lg:max-w-lg'
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
